module.exports = __webpack_public_path__ + "static/coupon-ru-79429e53d380c8c1f3a09ddb31b0ca36.png";